'use client';

import { RefObject, useEffect } from 'react';

export default function useDetectScrollOutside<T extends HTMLDivElement>(callback: () => void, ref: RefObject<T>) {
  useEffect(() => {
    function handleScrollOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    }
    document.addEventListener('scroll', handleScrollOutside);
    return () => {
      document.removeEventListener('scroll', handleScrollOutside);
    };
  }, [ref, callback]);
}
